module.exports = __webpack_public_path__ + "img/btn.13b5d2a9.png";